// Which answer are we still waiting for?
//
// Every async screen in this app has the same problem: the user changes their
// mind mid-request, an older extraction finishes after a newer one, and the
// slow answer overwrites the right one. Both Home and useRecipeSearch grew
// their own copy of this counter; this is that counter, once, so it can be
// tested on its own rather than through a component.
//
// NOT a mock. Real network latency makes this matter more, not less.

export function createRequestGuard() {
  let current = 0;

  return {
    // Claim the next slot. Whatever was in flight is now stale.
    begin: () => (current += 1),
    isCurrent: (token) => token === current,
    // Abandon everything in flight without starting anything new — this is
    // what an explicit cancel does.
    cancel: () => {
      current += 1;
    },
  };
}
